<div class="title">
  <p-heading [size]="'x-large'" [tag]="'h3'">Education Purpose</p-heading>

  <p-button
    [hideLabel]="(mediaMaxXs$ | async) ?? false"
    [iconSource]="'assets/icons/add.svg'"
    [variant]="'secondary'"
    (click)="showCreateModal = true"
  >
    Add New Purpose
  </p-button>
</div>

<p-divider aria-hidden="true" />

<section class="list">
  <p-heading *ngrxLet="data$ | async as purposes" [size]="'small'" [tag]="'h4'">
    {{ purposes?.length }} Purposes
  </p-heading>

  <ng-container *ngrxLet="data$ as data; error as dataError; suspenseTpl: spinner">
    <div *ngIf="dataError">
      <p-button-pure
        [hideLabel]="true"
        [iconSource]="'assets/icons/refresh.svg'"
        [size]="'large'"
        (click)="reloadData()"
      >
        Reload Purposes
      </p-button-pure>
    </div>

    <ng-container *ngIf="!dataError && data">
      <div class="overlay-spinner-host">
        <ng-container *ngIf="loading$ | async" [ngTemplateOutlet]="overlaySpinner" />

        <p-table caption="Edu Purpose list table">
          <p-table-head>
            <p-table-head-row>
              <p-table-head-cell style="width: 1%">Edit</p-table-head-cell>
              <p-table-head-cell style="width: 49%">Name</p-table-head-cell>
              <p-table-head-cell style="width: 49%">Type</p-table-head-cell>
              <p-table-head-cell style="width: 1%">Delete</p-table-head-cell>
            </p-table-head-row>
          </p-table-head>

          <p-table-body>
            <p-table-row *ngFor="let purpose of data; trackBy: trackEduExpensePurpose">
              <p-table-cell>
                <p-button-pure
                  [iconSource]="'assets/icons/edit.svg'"
                  [hideLabel]="true"
                  (click)="openEditModal(purpose)"
                >
                  Edit {{ purpose.description }}
                </p-button-pure>
              </p-table-cell>
              <p-table-cell>
                <p-link-pure [icon]="'none'" [underline]="true">
                  <a
                    [routerLink]="['/edu-transactions']"
                    [queryParams]="{ expensePurposeId: purpose.id }"
                  >
                    {{ purpose.description }}
                  </a>
                </p-link-pure>
              </p-table-cell>
              <p-table-cell>
                {{ budgetTypeTranslation[purpose.budgetType] | transloco }}
              </p-table-cell>
              <p-table-cell>
                <p-button-pure
                  [iconSource]="'assets/icons/delete.svg'"
                  [hideLabel]="true"
                  (click)="openDeleteModal(purpose)"
                >
                  Delete {{ purpose.description }}
                </p-button-pure>
              </p-table-cell>
            </p-table-row>
          </p-table-body>
        </p-table>
      </div>
    </ng-container>
  </ng-container>
</section>

<opa-edu-expense-purpose-create
  [open]="showCreateModal"
  (dismiss)="showCreateModal = false; $event && reloadData()"
/>

<ng-template #spinner>
  <div class="loading-spinner"><p-spinner /></div>
</ng-template>

<ng-template #overlaySpinner>
  <div class="overlay-spinner"><p-spinner /></div>
</ng-template>

<opa-edu-expense-purpose-delete
  [open]="showDeleteModal"
  [eduExpensePurpose]="(eduExpensePurpose$ | async) ?? undefined"
  (dismiss)="closeDeleteModal($event)"
/>

<opa-edu-expense-purpose-edit
  [open]="showEditModal"
  [eduExpensePurpose]="(eduExpensePurpose$ | async) ?? undefined"
  (dismiss)="closeEditModal($event)"
/>
